import React, { useState, useContext, useEffect } from 'react';
import './horizontalTabsAdmin.scss';
import { useLocation, useSearchParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Link, Filters } from '@ui-kit';
import { SearchFormBg } from '@features';
import { ADMIN_USERS_URL, ADMIN_MANAGEMENT_SETTINGS_URL, ADMIN_STATISTICS_URL } from '@app/routes';

import { ROLES } from '@entities/user';
import {
  getUserRole,
  getUsersTC,
  getSettingsTC,
  getSearchPage,
} from '@entities';
import RefreshIcon from '@ui-kit/icons/refresh-cw-gray500.svg';
import { UsersContext } from '@shared/hooks';

const HorizontalTabsAdmin = () => {
  const dispatch = useDispatch();
  const location = useLocation();

  const usersContext = useContext(UsersContext);
  const role = useSelector(getUserRole);
  const searchPage = useSelector(getSearchPage);
  const [searchValue, setSearchValue] = useState('');
  const [searchParams, setSearchParams] = useSearchParams();

  const isAdmin = role === ROLES.ADMIN;
  let filtersList = [];
  let filterOrder = '';
  let actions = '';

  useEffect(() => {
    const search = searchParams.get('search');
    if (search && !searchValue) {
      setSearchValue(search);
    };
    // eslint-disable-next-line
  }, []);

  const resetFilter = (filterOrder) => {
    searchParams.delete(filterOrder);
    setSearchParams(searchParams, {replace: true});

    onUpdateData();
  }

  const searchPlaceholder = () => {
    switch (searchPage) {
      case 'users': {
        filterOrder = 'search';
        filtersList = [
          { name: 'Users', value: 'user' },
          { name: 'Admins', value: 'admin' },
        ];
        actions = (
          <div className="filter-actions__line">
            <Button 
              size="sm" 
              theme="link-gray"
              onClick={() => resetFilter(filterOrder)}
            >Reset</Button>
          </div>
        );
        return 'Search by users';
      }

      default:
        return 'Search by';
    };
  };

  const onSubmitSearch = (e) => {
    e.preventDefault();
  };

  const onChangeSearch = async(event) => {
    const value = event?.target?.value || '';

    setSearchValue(value);

    switch (searchPage) {
      case 'users': {
        await usersContext.onUsersSearch(value);
        break;
      }

      default : break;
    };
        
    event.preventDefault();
  };

  const isActiveButton = (url) => {
    const path = url.pathname;

    if (path === location.pathname) {
      return 'active';
    }

    return '';
  };

  const onUpdateData = () => {
    switch (searchPage) {
      case 'users': {
        dispatch(getUsersTC({ limit: 30, page: 1 }));
        break;
      }

      case 'settings': {
        dispatch(getSettingsTC());
        break;
      }
      
      default : break;
    };
  };

  const onChangeFilter = () => {
    const search = window.location.search;
    switch (searchPage) {
      case 'users': {
        dispatch(getUsersTC(search));
        break;
      }

      case 'settings': {
        dispatch(getSettingsTC());
        break;
      }
      
      default : break;
    }
  };

  const renderFilters = () => {
    return (
      <Filters 
      filters={filtersList} 
      filterOrder={filterOrder} 
      actions={actions}
      onChangeFilter={onChangeFilter}
    />
    );
  };

  return (
    <div className="admin-navigate d-flex df-column jc-sb">
      <div className="admin-navigate__menu d-flex df-column">
        <Button
          theme="link-gray"
          size="lg"
          iconRight={RefreshIcon}
          className="mr-32 refresh-page"
          onClick={onUpdateData}
        />
        <div className="admin-navigate__tab d-flex df-column">
          {isAdmin && (
            <>
              <Link
                to={ADMIN_USERS_URL}
                theme="text"
                className={`tab-link ${isActiveButton(ADMIN_USERS_URL)}`}
              >
                Users
              </Link>
              <Link
                to={ADMIN_STATISTICS_URL}
                theme="text"
                className={`tab-link ${isActiveButton(ADMIN_STATISTICS_URL)}`}
              >
                Statistics
              </Link>
              <Link
              to={ADMIN_MANAGEMENT_SETTINGS_URL}
              theme="text"
              className={`tab-link ${isActiveButton(ADMIN_MANAGEMENT_SETTINGS_URL)}`}
            >
              Settings
            </Link>
          </>
          )}
        </div>
      </div>
      {searchPage === 'users' &&
        <div className="admin-navigate__search d-flex df-column">
          <SearchFormBg
            onSubmit={onSubmitSearch}
            onChange={onChangeSearch}
            placeholder={searchPlaceholder()}
            className="mr-32"
            value={searchValue}
          />
          {renderFilters()}
        </div>
      }
    </div>
  );
};

export default HorizontalTabsAdmin;
